import * as React from 'react';
import { Chip as MatChip, SxProps, Theme } from '@mui/material';

type TColorType = 'primary' | 'secondary' | 'default' | undefined;

export interface ChipProps {
  id?: string;
  label: string;
  onClick?: () => void;
  onDelete?: () => void;
  color?: TColorType;
  icon?: React.ReactElement;
  className?: string;
  clickable?: boolean;
  sx?: SxProps<Theme>;
}

const Chip: React.FunctionComponent<ChipProps> = ({ id, label, onClick, onDelete, color, icon, className, clickable, sx }) => {
  return (
    <MatChip
      id={id}
      label={label}
      onClick={onClick}
      onDelete={onDelete}
      color={color}
      icon={icon}
      clickable={clickable}
      className={className}
      aria-label={label}
      sx={sx}
    />
  );
};

Chip.defaultProps = {
  label: 'label'
};

Chip.displayName = 'Chip';

export { Chip };
